/**
 * eQuote Design System - Spacing & Layout
 */

export const spacing = {
  0:  0,
  0.5: 2,
  1:  4,
  1.5: 6,
  2:  8,
  2.5: 10,
  3:  12,
  4:  16,
  5:  20,
  6:  24,
  8:  32,
  10: 40,
  12: 48,
  16: 64,
} as const;

export const borderRadius = {
  sm:    4,
  DEFAULT: 8,
  md:    12,
  lg:    16,
  xl:    24,
  '2xl': 32,
  full:  9999,
} as const;

export const APP_BAR_HEIGHT = 64;
export const BOTTOM_NAV_HEIGHT = 64;
export const SAFE_BOTTOM = 16;

export const shadows = {
  sm:  '0 1px 3px rgba(0,0,0,0.06)',
  md:  '0 4px 12px rgba(0,0,0,0.08)',
  lg:  '0 8px 32px rgba(0,0,0,0.10)',
  xl:  '0 -10px 40px rgba(0,0,0,0.12)',
  fab: '0 8px 24px rgba(0,51,102,0.3)',
} as const;
